import { useState, useContext, useEffect } from "react";
import Select from "react-select";
import Flatpickr from "react-flatpickr";
import moment from "moment";
import axios from "axios";
import Header from "../layout/Header";
import Footer from "../layout/Footer";
import Loader from "../layout/Loader";
import { alertContext } from "../contexts/AlertProvider";
import Alert from "../Alert";
import PermissionGate from "../layout/PermissionGate";
import BillingAddress from "../layout/BillingAddress";
import LegalAddress from "../layout/LegalAddress";
import normalize from "../utils/NormalizeSelect";

const CreateMerchant = () => {
  const [data, setData] = useState({});
  const [error, setError] = useState({});
  const [models, setModels] = useState([]);
  const [stage, setStage] = useState("info");
  const [loadingStep, setLoadingStep] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [alertConfig, setAlertConfig] = useContext(alertContext);
  const token = localStorage.getItem("token");

  const processData = (type, event, field) => {
    if (type === "text") {
      const value = event.target.value;
      const newData = { ...data };
      newData[field] = value;
      const newError = { ...error };
      newError[field] = "";
      delete newError[field];
      setData({ ...newData });
      setError({ ...newError });
    }
    if (type === "select") {
      const value = event?.value;
      const newData = { ...data };
      newData[field] = value;
      const newError = { ...error };
      newError[field] = "";
      delete newError[field];
      setData({ ...newData });
      setError({ ...newError });
    }
    if (type === "date") {
      const value = moment(event).format("DD-MM-YYYY");
      const newData = { ...data };
      newData[field] = value;
      const newError = { ...error };
      newError[field] = "";
      delete newError[field];
      setData({ ...newData });
      setError({ ...newError });
    }
    if (type === "file") {
      setLoadingStep(field);
      const file = event.target.files[0];
      if (file) {
        const reader = new FileReader();
        reader.onloadend = async () => {
          const base64 = reader.result.split(",")[1];
          const extensionMatch = file.name.match(/\.([^.]+)$/);
          const extension = extensionMatch[1].toLowerCase();
          const fileName = file.name;
          const fileObject = {
            type: extension,
            content: base64,
            fileName: fileName,
          };
          axios
            .post(
              process.env.REACT_APP_API_ENDPOINT + "upload-file",
              {
                file: fileObject,
              },
              {
                headers: {
                  Authorization: `Bearer ${token}`,
                },
              },
            )
            .then((res) => {
              const newData = { ...data };
              newData[field] = res.data.data;
              const newError = { ...error };
              newError[field] = "";
              delete newError[field];
              setData({ ...newData });
              setError({ ...newError });
              setLoadingStep("");
            })
            .catch((error) => {
              console.error(error);
            });
        };
        reader.readAsDataURL(file);
      }
    }
    if (type === "checkbox") {
      const value = event;
      const newData = { ...data };
      newData[field] = value;
      const newError = { ...error };
      newError[field] = "";
      delete newError[field];
      setData({ ...newData });
      setError({ ...newError });
    }
  };
  const validateInfo = () => {
    const errors = {};
    if (data.merchantName === undefined || data.merchantName === "") {
      errors["merchantName"] = "Please enter merchant name";
    }
    if (data.legalName === undefined || data.legalName === "") {
      errors["legalName"] = "Please enter legal name";
    }
    if (data.merchantType === undefined || data.merchantType === "") {
      errors["merchantType"] = "Please select merchant type";
    }
    if (data.currency === undefined || data.currency === "") {
      errors["currency"] = "Please select currency";
    }
    setError({ ...errors });
    if (
      errors.merchantName === undefined &&
      errors.legalName === undefined &&
      errors.merchantType === undefined &&
      errors.currency === undefined
    ) {
      setStage("documents");
    }
  };
  const validateDocuments = () => {
    const errors = {};
    if (data.licenceExpiary === undefined || data.licenceExpiary === "") {
      errors["licenceExpiary"] = "Please select licence expiary date";
    }
    if (data.licensePhoto === undefined || data.licensePhoto === "") {
      errors["licensePhoto"] = "Please upload license photo";
    }
    if (data.contractPhoto === undefined || data.contractPhoto === "") {
      errors["contractPhoto"] = "Please upload contract photo";
    }
    if (data.merchantLogo === undefined || data.merchantLogo === "") {
      errors["merchantLogo"] = "Please upload merchant logo";
    }
    if (data.signatoryDocument === undefined || data.signatoryDocument === "") {
      errors["signatoryDocument"] = "Please upload signatory document";
    }
    if (
      data.articlesOfAssociation === undefined ||
      data.articlesOfAssociation === ""
    ) {
      errors["articlesOfAssociation"] = "Please upload articles of association";
    }
    if (data.pricingModel === undefined || data.pricingModel === "") {
      errors["pricingModel"] = "Please select pricing model";
    }

    setError({ ...errors });
    if (
      errors.licenceExpiary === undefined &&
      errors.licensePhoto === undefined &&
      errors.contractPhoto === undefined &&
      errors.merchantLogo === undefined &&
      errors.signatoryDocument === undefined &&
      errors.articlesOfAssociation === undefined &&
      errors.pricingModel === undefined
    ) {
      setStage("addresses");
    }
  };
  const validateAddresses = () => {
    const errors = {};
    if (
      data.billingArea === undefined ||
      data.billingArea === "" ||
      data.billingArea === null
    ) {
      errors["billingArea"] = "Please select billing area";
    }
    if (
      data.billingBlock === undefined ||
      data.billingBlock === "" ||
      data.billingBlock === null
    ) {
      errors["billingBlock"] = "Please select billing block";
    }
    if (
      data.billingStreet === undefined ||
      data.billingStreet === "" ||
      data.billingStreet === null
    ) {
      errors["billingStreet"] = "Please select billing street";
    }
    if (
      data.billingBuildingNoOrName === undefined ||
      data.billingBuildingNoOrName === ""
    ) {
      errors["billingBuildingNoOrName"] = "Please enter building no";
    }
    if (data.billingJadda === undefined || data.billingJadda === "") {
      errors["billingJadda"] = "Please enter billing jadda";
    }
    if (
      data.billingApartmentOrOffice === undefined ||
      data.billingApartmentOrOffice === ""
    ) {
      errors["billingApartmentOrOffice"] = "Please enter apartment name";
    }
    if (data.billingFloor === undefined || data.billingFloor === "") {
      errors["billingFloor"] = "Please enter billing floor";
    }
    if (
      data.billingLatitude !== undefined &&
      data.billingLatitude !== null &&
      String(data.billingLatitude).trim() !== "" &&
      isNaN(parseFloat(data.billingLatitude))
    ) {
      errors["billingLatitude"] = "Please Enter Latitude";
    }
    if (
      data.billingLongitude !== undefined &&
      data.billingLongitude !== null &&
      String(data.billingLongitude).trim() !== "" &&
      isNaN(parseFloat(data.billingLongitude))
    ) {
      errors["billingLongitude"] = "Please Enter Longitude";
    }
    if (
      data.legalArea === undefined ||
      data.legalArea === "" ||
      data.legalArea === null
    ) {
      errors["legalArea"] = "Please select legal area";
    }
    if (
      data.legalBlock === undefined ||
      data.legalBlock === "" ||
      data.legalBlock === null
    ) {
      errors["legalBlock"] = "Please select legal block";
    }
    if (
      data.legalStreet === undefined ||
      data.legalStreet === "" ||
      data.legalStreet === null
    ) {
      errors["legalStreet"] = "Please select legal street";
    }
    if (
      data.legalBuildingNoOrName === undefined ||
      data.legalBuildingNoOrName === ""
    ) {
      errors["legalBuildingNoOrName"] = "Please enter building no";
    }
    if (data.legalJadda === undefined || data.legalJadda === "") {
      errors["legalJadda"] = "Please enter legal jadda";
    }
    if (
      data.legalApartmentOrOffice === undefined ||
      data.legalApartmentOrOffice === ""
    ) {
      errors["legalApartmentOrOffice"] = "Please enter apartment name";
    }
    if (data.legalFloor === undefined || data.legalFloor === "") {
      errors["legalFloor"] = "Please enter legal floor";
    }
    if (
      data.legalLatitude !== undefined &&
      data.legalLatitude !== null &&
      String(data.legalLatitude).trim() !== "" &&
      isNaN(parseFloat(data.legalLatitude))
    ) {
      errors["legalLatitude"] = "Please Enter Latitude";
    }
    if (
      data.legalLongitude !== undefined &&
      data.legalLongitude !== null &&
      String(data.legalLongitude).trim() !== "" &&
      isNaN(parseFloat(data.legalLongitude))
    ) {
      errors["legalLongitude"] = "Please Enter Longitude";
    }
    if (data.mainBranchPhone === undefined || data.mainBranchPhone === "") {
      errors["mainBranchPhone"] = "Please enter phone number";
    }

    setError({ ...errors });
    if (
      errors.billingArea === undefined &&
      errors.billingBlock === undefined &&
      errors.billingStreet === undefined &&
      errors.billingBuildingNoOrName === undefined &&
      errors.billingJadda === undefined &&
      errors.billingApartmentOrOffice === undefined &&
      errors.billingFloor === undefined &&
      errors.billingLatitude === undefined &&
      errors.billingLongitude === undefined &&
      errors.legalArea === undefined &&
      errors.legalBlock === undefined &&
      errors.legalStreet === undefined &&
      errors.legalBuildingNoOrName === undefined &&
      errors.legalJadda === undefined &&
      errors.legalApartmentOrOffice === undefined &&
      errors.legalFloor === undefined &&
      errors.legalLatitude === undefined &&
      errors.legalLongitude === undefined &&
      errors.mainBranchPhone === undefined
    ) {
      setIsLoading(true);
      axios
        .post(process.env.REACT_APP_API_ENDPOINT + "create-merchant", data, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        .then((res) => {
          if (res) {
            setData({});
            setError({});
            setStage("info");
            setIsLoading(false);
            if (res.data.code === 0) {
              setAlertConfig({
                show: true,
                message: res.data.message,
                type: "danger",
              });
            }
            if (res.data.code === 1) {
              setAlertConfig({
                show: true,
                message: res.data.message,
                type: "success",
              });
            }
          }
        })
        .catch(console.error);
    }
  };
  const fetchPricingModels = () => {
    axios
      .get(`${process.env.REACT_APP_API_ENDPOINT}pricing/list`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((res) => {
        if (res.data.code === 1) {
          setModels(res.data.data);
        }
      })
      .catch(console.error);
  };

  useEffect(() => {
    if (data?.billingAndLegalAddressSame === true) {
      setData({
        ...data,
        legalArea: data?.billingArea ?? null,
        legalBlock: data?.billingBlock ?? null,
        legalStreet: data?.billingStreet ?? null,
        legalBuildingNoOrName: data?.billingBuildingNoOrName ?? "",
        legalJadda: data?.billingJadda ?? "",
        legalApartmentOrOffice: data?.billingApartmentOrOffice ?? "",
        legalFloor: data?.billingFloor ?? "",
        legalLatitude: isNaN(parseFloat(data?.billingLatitude))
          ? ""
          : parseFloat(data?.billingLatitude),
        legalLongitude: isNaN(parseFloat(data?.billingLongitude))
          ? ""
          : parseFloat(data?.billingLongitude),
      });
      setError({
        ...error,
        legalArea: "",
        legalBlock: "",
        legalStreet: "",
        legalBuildingNoOrName: "",
        legalJadda: "",
        legalApartmentOrOffice: "",
        legalFloor: "",
        legalLatitude: null,
        legalLongitude: null,
      });
    } else {
      setData({
        ...data,
        legalArea: null,
        legalBlock: null,
        legalStreet: null,
        legalBuildingNoOrName: "",
        legalJadda: "",
        legalApartmentOrOffice: "",
        legalFloor: "",
        legalLatitude: null,
        legalLongitude: null,
      });
      setError({
        ...error,
        legalArea: "",
        legalBlock: "",
        legalStreet: "",
        legalBuildingNoOrName: "",
        legalJadda: "",
        legalApartmentOrOffice: "",
        legalFloor: "",
        legalLatitude: null,
        legalLongitude: null,
      });
    }
  }, [data?.billingAndLegalAddressSame]);
  useEffect(() => {
    fetchPricingModels();
  }, []);

  return isLoading === true ? (
    <Loader />
  ) : (
    <div className="d-flex flex-column flex-root">
      <Alert />
      {/*begin::Page*/}
      <div className="page d-flex flex-row flex-column-fluid">
        {/*begin::Wrapper*/}
        <div
          className="wrapper d-flex flex-column flex-row-fluid"
          id="kt_wrapper"
        >
          <Header />
          <div className="app-body">
            <div className="toolbar py-3 py-lg-6" id="kt_toolbar">
              {/*begin::Container*/}
              <div
                id="kt_toolbar_container"
                className=" container-xxl  d-flex flex-stack flex-wrap gap-2"
              >
                {/*begin::Page title*/}
                <div className="page-title d-flex flex-column align-items-start me-3 py-2 py-lg-0 gap-2">
                  {/*begin::Title*/}
                  <h1 className="d-flex text-dark fw-bold m-0 fs-3">
                    Create New Merchant
                  </h1>
                  {/*end::Title*/}
                </div>
                {/*end::Page title*/}
              </div>
              {/*end::Container*/}
            </div>
            {/*end::Toolbar*/}
            {/*begin::Container*/}
            <div
              id="kt_content_container"
              className="d-flex flex-column-fluid align-items-start  container-xxl "
            >
              {/*begin::Post*/}
              <div className="content flex-row-fluid" id="kt_content">
                {/*begin::Card*/}
                <PermissionGate required={`create_new_merchant`}>
                  <div className="card">
                    {/*begin::Card body*/}
                    <div className="card-body py-4">
                      {/*begin::Main*/}
                      {/*begin::Root*/}
                      <div className="d-flex flex-column flex-root">
                        {/*begin::Authentication - Multi-steps*/}
                        <div
                          className="d-flex flex-column flex-lg-row flex-column-fluid stepper stepper-pills stepper-column stepper-multistep"
                          id="kt_create_account_stepper"
                        >
                          {/*begin::Body*/}
                          <div className="d-flex flex-row-fluid justify-content-center align-items-center p-10 bg-primary rounded">
                            {/*begin::Nav*/}
                            <div className="stepper-nav">
                              {/*begin::Step 1*/}
                              <div
                                className={
                                  stage === "info"
                                    ? "stepper-item current"
                                    : "stepper-item"
                                }
                                data-kt-stepper-element="nav"
                              >
                                {/*begin::Wrapper*/}
                                <div className="stepper-wrapper">
                                  {/*begin::Icon*/}
                                  <div className="stepper-icon rounded-3">
                                    <i className="bi-duotone bi-check-circle-fill fs-2 stepper-check"></i>
                                    <span className="stepper-number">1</span>
                                  </div>
                                  {/*end::Icon*/}

                                  {/*begin::Label*/}
                                  <div className="stepper-label">
                                    <p className="stepper-title fs-2">Info</p>
                                  </div>
                                  {/*end::Label*/}
                                </div>
                                {/*end::Wrapper*/}

                                {/*begin::Line*/}
                                <div className="stepper-line h-40px"></div>
                                {/*end::Line*/}
                              </div>
                              {/*end::Step 1*/}

                              {/*begin::Step 2*/}
                              <div
                                className={
                                  stage === "documents"
                                    ? "stepper-item current"
                                    : "stepper-item"
                                }
                                data-kt-stepper-element="nav"
                              >
                                {/*begin::Wrapper*/}
                                <div className="stepper-wrapper">
                                  {/*begin::Icon*/}
                                  <div className="stepper-icon rounded-3">
                                    <i className="bi-duotone bi-check-circle-fill fs-2 stepper-check"></i>
                                    <span className="stepper-number">2</span>
                                  </div>
                                  {/*end::Icon*/}

                                  {/*begin::Label*/}
                                  <div className="stepper-label">
                                    <h4 className="stepper-title fs-2">
                                      Documents
                                    </h4>
                                  </div>
                                  {/*end::Label*/}
                                </div>
                                {/*end::Wrapper*/}

                                {/*begin::Line*/}
                                <div className="stepper-line h-40px"></div>
                                {/*end::Line*/}
                              </div>
                              {/*end::Step 2*/}

                              {/*begin::Step 3*/}
                              <div
                                className={
                                  stage === "addresses"
                                    ? "stepper-item current"
                                    : "stepper-item"
                                }
                                data-kt-stepper-element="nav"
                              >
                                {/*begin::Wrapper*/}
                                <div className="stepper-wrapper">
                                  {/*begin::Icon*/}
                                  <div className="stepper-icon">
                                    <i className="ki-duotone ki-check fs-2 stepper-check"></i>
                                    <span className="stepper-number">3</span>
                                  </div>
                                  {/*end::Icon*/}

                                  {/*begin::Label*/}
                                  <div className="stepper-label">
                                    <h4 className="stepper-title fs-2">
                                      Addresses
                                    </h4>
                                  </div>
                                  {/*end::Label*/}
                                </div>
                                {/*end::Wrapper*/}
                              </div>
                              {/*end::Step 3*/}
                            </div>
                            {/*end::Nav*/}
                          </div>
                          {/*end::Body*/}

                          {/*begin::Body*/}
                          <div className="d-flex flex-column flex-lg-row-fluid">
                            {/*begin::Content*/}
                            <div className="d-flex flex-center flex-column flex-column-fluid">
                              {/*begin::Wrapper*/}
                              <div className="w-lg-650px w-xl-700px mx-auto">
                                {/*begin::Form*/}
                                <form
                                  className="my-auto pb-5"
                                  noValidate="novalidate"
                                  id="kt_create_account_form"
                                >
                                  {/*begin::Step 1*/}
                                  {stage === "info" ? (
                                    <div className="current">
                                      {/*begin::Wrapper*/}
                                      <div className="w-100">
                                        {/*begin::Heading*/}
                                        <div className="pb-10 pt-5 pb-lg-15">
                                          {/*begin::Title*/}
                                          <h2 className="fw-bold d-flex align-items-center text-dark">
                                            Merchant Information
                                          </h2>
                                          {/*end::Title*/}
                                        </div>
                                        {/*end::Heading*/}

                                        {/*begin::Input group*/}
                                        <div className="fv-row fv-plugins-icon-container fv-plugins-bootstrap5-row-valid">
                                          {/*begin::Row*/}
                                          <div className="row">
                                            {/*begin::Col*/}
                                            <div className="col-md-6">
                                              <div className="fv-row mb-10 fv-plugins-icon-container fv-plugins-bootstrap5-row-invalid">
                                                {/*begin::Input*/}
                                                <label className="form-label required">
                                                  Merchant Name
                                                </label>
                                                <input
                                                  autoComplete="off"
                                                  className="form-control"
                                                  placeholder="Enter Merchant Name"
                                                  value={
                                                    data?.merchantName ?? ""
                                                  }
                                                  onChange={(e) => {
                                                    processData(
                                                      "text",
                                                      e,
                                                      "merchantName",
                                                    );
                                                  }}
                                                />
                                                {error.merchantName !==
                                                  undefined &&
                                                  error.merchantName !== "" ? (
                                                  <small className="text-danger mt-2">
                                                    {error.merchantName}
                                                  </small>
                                                ) : (
                                                  ""
                                                )}
                                                {/*end::Input*/}
                                                <div className="fv-plugins-message-container fv-plugins-message-container--enabled invalid-feedback"></div>
                                              </div>
                                            </div>
                                            <div className="col-md-6">
                                              <div className="fv-row mb-10 fv-plugins-icon-container fv-plugins-bootstrap5-row-invalid">
                                                {/*begin::Input*/}
                                                <label className="form-label required">
                                                  Legal Name
                                                </label>
                                                <input
                                                  autoComplete="off"
                                                  className="form-control"
                                                  placeholder="Enter Legal Name"
                                                  value={data?.legalName ?? ""}
                                                  onChange={(e) => {
                                                    processData(
                                                      "text",
                                                      e,
                                                      "legalName",
                                                    );
                                                  }}
                                                />
                                                {error.legalName !==
                                                  undefined &&
                                                  error.legalName !== "" ? (
                                                  <small className="text-danger mt-2">
                                                    {error.legalName}
                                                  </small>
                                                ) : (
                                                  ""
                                                )}
                                                {/*end::Input*/}
                                                <div className="fv-plugins-message-container fv-plugins-message-container--enabled invalid-feedback"></div>
                                              </div>
                                            </div>
                                            <div className="col-md-6">
                                              <div className="fv-row mb-10 fv-plugins-icon-container">
                                                <div className="fv-row">
                                                  {/*begin::Label*/}
                                                  <label className="required form-label">
                                                    Merchant Type
                                                  </label>
                                                  {/*end::Label*/}
                                                  {/*begin::Select2*/}
                                                  <Select
                                                    className="react-select-styled react-select-bordered"
                                                    classNamePrefix="react-select"
                                                    defaultInputValue={
                                                      data.merchantType
                                                    }
                                                    onChange={(e) => {
                                                      processData(
                                                        "select",
                                                        e,
                                                        "merchantType",
                                                      );
                                                    }}
                                                    options={[
                                                      {
                                                        value: "Regular",
                                                        label: "Regular",
                                                      },
                                                      {
                                                        value: "Ecommerce",
                                                        label: "Ecommerce",
                                                      },
                                                      {
                                                        value: "API User",
                                                        label: "API User",
                                                      },
                                                      {
                                                        value: "Customer",
                                                        label: "Customer",
                                                      },
                                                    ]}
                                                    filterOption={(option, input) => {
                                                      return normalize(option.label).includes(normalize(input));
                                                    }}
                                                    placeholder="Select an option"
                                                  />
                                                  {error.merchantType !==
                                                    undefined &&
                                                    error.merchantType !== "" ? (
                                                    <small className="text-danger mt-2">
                                                      {error.merchantType}
                                                    </small>
                                                  ) : (
                                                    ""
                                                  )}
                                                  {/*end::Select2*/}
                                                </div>
                                                <div className="fv-plugins-message-container fv-plugins-message-container--enabled invalid-feedback"></div>
                                              </div>
                                            </div>
                                            <div className="col-md-6">
                                              <div className="fv-row mb-10 fv-plugins-icon-container">
                                                <div className="fv-row mb-10">
                                                  {/*begin::Label*/}
                                                  <label className="form-label required">
                                                    Currency
                                                  </label>
                                                  {/*end::Label*/}

                                                  {/*begin::Input*/}
                                                  <Select
                                                    className="react-select-styled react-select-bordered"
                                                    classNamePrefix="react-select"
                                                    defaultInputValue={
                                                      data.currency
                                                    }
                                                    onChange={(e) => {
                                                      processData(
                                                        "select",
                                                        e,
                                                        "currency",
                                                      );
                                                    }}
                                                    options={[
                                                      {
                                                        value: "KWD",
                                                        label: "KWD",
                                                      },
                                                      {
                                                        value: "JOD",
                                                        label: "JOD",
                                                      },
                                                      {
                                                        value: "SAR",
                                                        label: "SAR",
                                                      },
                                                      {
                                                        value: "AED",
                                                        label: "AED",
                                                      },
                                                      {
                                                        value: "BHD",
                                                        label: "BHD",
                                                      },
                                                      {
                                                        value: "QAR",
                                                        label: "QAR",
                                                      },
                                                      {
                                                        value: "EGP",
                                                        label: "EGP",
                                                      },
                                                    ]}
                                                    filterOption={(option, input) => {
                                                      return normalize(option.label).includes(normalize(input));
                                                    }}
                                                    placeholder="Select an option"
                                                  />
                                                  {error.currency !==
                                                    undefined &&
                                                    error.currency !== "" ? (
                                                    <small className="text-danger mt-2">
                                                      {error.currency}
                                                    </small>
                                                  ) : (
                                                    ""
                                                  )}
                                                  {/*end::Input*/}
                                                </div>
                                                <div className="fv-plugins-message-container fv-plugins-message-container--enabled invalid-feedback"></div>
                                              </div>
                                            </div>
                                            {/*end::Col*/}
                                          </div>
                                          {/*end::Row*/}
                                        </div>
                                        {/*end::Input group*/}
                                      </div>
                                      {/*end::Wrapper*/}
                                      {/*begin::Actions*/}
                                      <div className="d-flex flex-stack">
                                        <div className="mr-2"></div>

                                        <div>
                                          <button
                                            type="button"
                                            className="btn btn-lg btn-primary"
                                            onClick={validateInfo}
                                          >
                                            Next
                                            <i className="bi-duotone bi-arrow-right fs-4 ms-1">
                                              <span className="path1"></span>
                                              <span className="path2"></span>
                                            </i>
                                          </button>
                                        </div>
                                      </div>
                                      {/*end::Actions*/}
                                    </div>
                                  ) : (
                                    ""
                                  )}

                                  {/*end::Step 1*/}

                                  {/*begin::Step 2*/}
                                  {stage === "documents" ? (
                                    <div className="current">
                                      {/*begin::Wrapper*/}
                                      <div className="w-100">
                                        {/*begin::Heading*/}
                                        <div className="pb-10 pt-5 pb-lg-15">
                                          {/*begin::Title*/}
                                          <h2 className="fw-bold d-flex align-items-center text-dark">
                                            Merchant Documents
                                          </h2>
                                          {/*end::Title*/}
                                        </div>
                                        {/*end::Heading*/}

                                        {/*begin::Input group*/}
                                        <div className="fv-row">
                                          {/*begin::Row*/}
                                          <div className="row">
                                            {/*begin::Col*/}
                                            <div className="col-md-6">
                                              <div className="fv-row fv-plugins-icon-container">
                                                {/*begin::Label*/}
                                                <label className="required form-label">
                                                  Licence Expiary
                                                </label>
                                                {/*end::Label*/}

                                                {/*begin::Editor*/}
                                                <Flatpickr
                                                  options={{
                                                    dateFormat: "d-m-Y",
                                                  }}
                                                  value={
                                                    data.licenceExpiary ===
                                                      undefined
                                                      ? new Date()
                                                      : data.licenceExpiary
                                                  }
                                                  onChange={([
                                                    licenceExpiary,
                                                  ]) => {
                                                    processData(
                                                      "date",
                                                      licenceExpiary,
                                                      "licenceExpiary",
                                                    );
                                                  }}
                                                  className="form-control"
                                                  placeholder="Pick date"
                                                />
                                                {error.licenceExpiary !==
                                                  undefined &&
                                                  error.licenceExpiary !== "" ? (
                                                  <small className="text-danger mt-2">
                                                    {error.licenceExpiary}
                                                  </small>
                                                ) : (
                                                  ""
                                                )}
                                                {/*end::Editor*/}
                                                <div className="fv-plugins-message-container fv-plugins-message-container--enabled invalid-feedback"></div>
                                              </div>
                                            </div>
                                            <div className="col-md-6">
                                              <div className="fv-row mb-10 fv-plugins-icon-container">
                                                {/*begin::Input*/}
                                                <label className="form-label required">
                                                  License Photo
                                                </label>
                                                <input
                                                  autoComplete="off"
                                                  type="file"
                                                  className="form-control"
                                                  id="licence_photo"
                                                  placeholder="Enter Legal Name"
                                                  onChange={(e) => {
                                                    processData(
                                                      "file",
                                                      e,
                                                      "licensePhoto",
                                                    );
                                                  }}
                                                />
                                                {error.licensePhoto !==
                                                  undefined &&
                                                  error.licensePhoto !== "" ? (
                                                  <small className="text-danger mt-2">
                                                    {error.licensePhoto}
                                                  </small>
                                                ) : (
                                                  ""
                                                )}
                                                {loadingStep ===
                                                  "licensePhoto" ? (
                                                  <small className="text-warning mt-2">
                                                    Please Wait File Uploding...
                                                  </small>
                                                ) : (
                                                  ""
                                                )}
                                                {/*end::Input*/}
                                                <div className="fv-plugins-message-container fv-plugins-message-container--enabled invalid-feedback"></div>
                                              </div>
                                            </div>
                                            <div className="col-md-6">
                                              <div className="fv-row mb-10 fv-plugins-icon-container">
                                                {/*begin::Input*/}
                                                <label className="form-label required">
                                                  Contract Photo
                                                </label>
                                                <input
                                                  autoComplete="off"
                                                  type="file"
                                                  id="contract_photo"
                                                  className="form-control"
                                                  onChange={(e) => {
                                                    processData(
                                                      "file",
                                                      e,
                                                      "contractPhoto",
                                                    );
                                                  }}
                                                />
                                                {error.contractPhoto !==
                                                  undefined &&
                                                  error.contractPhoto !== "" ? (
                                                  <small className="text-danger mt-2">
                                                    {error.contractPhoto}
                                                  </small>
                                                ) : (
                                                  ""
                                                )}
                                                {loadingStep ===
                                                  "contractPhoto" ? (
                                                  <small className="text-warning mt-2">
                                                    Please Wait File Uploding...
                                                  </small>
                                                ) : (
                                                  ""
                                                )}
                                                {/*end::Input*/}
                                                <div className="fv-plugins-message-container fv-plugins-message-container--enabled invalid-feedback"></div>
                                              </div>
                                            </div>
                                            <div className="col-md-6">
                                              <div className="fv-row mb-10 fv-plugins-icon-container">
                                                {/*begin::Input*/}
                                                <label className="form-label required">
                                                  Merchant Logo
                                                </label>
                                                <input
                                                  autoComplete="off"
                                                  type="file"
                                                  id="merchant_logo"
                                                  className="form-control"
                                                  onChange={(e) => {
                                                    processData(
                                                      "file",
                                                      e,
                                                      "merchantLogo",
                                                    );
                                                  }}
                                                />
                                                {error.merchantLogo !==
                                                  undefined &&
                                                  error.merchantLogo !== "" ? (
                                                  <small className="text-danger mt-2">
                                                    {error.merchantLogo}
                                                  </small>
                                                ) : (
                                                  ""
                                                )}
                                                {loadingStep ===
                                                  "merchantLogo" ? (
                                                  <small className="text-warning mt-2">
                                                    Please Wait File Uploding...
                                                  </small>
                                                ) : (
                                                  ""
                                                )}
                                                {/*end::Input*/}
                                                <div className="fv-plugins-message-container fv-plugins-message-container--enabled invalid-feedback"></div>
                                              </div>
                                            </div>
                                            <div className="col-md-6">
                                              <div className="fv-row mb-10 fv-plugins-icon-container">
                                                {/*begin::Input*/}
                                                <label className="form-label required">
                                                  Signatory Document
                                                </label>
                                                <input
                                                  autoComplete="off"
                                                  type="file"
                                                  id="signatory_document"
                                                  className="form-control"
                                                  onChange={(e) => {
                                                    processData(
                                                      "file",
                                                      e,
                                                      "signatoryDocument",
                                                    );
                                                  }}
                                                />
                                                {error.signatoryDocument !==
                                                  undefined &&
                                                  error.signatoryDocument !==
                                                  "" ? (
                                                  <small className="text-danger mt-2">
                                                    {error.signatoryDocument}
                                                  </small>
                                                ) : (
                                                  ""
                                                )}
                                                {loadingStep ===
                                                  "signatoryDocument" ? (
                                                  <small className="text-warning mt-2">
                                                    Please Wait File Uploding...
                                                  </small>
                                                ) : (
                                                  ""
                                                )}
                                                {/*end::Input*/}
                                                <div className="fv-plugins-message-container fv-plugins-message-container--enabled invalid-feedback"></div>
                                              </div>
                                            </div>
                                            <div className="col-md-6">
                                              <div className="fv-row mb-10 fv-plugins-icon-container">
                                                {/*begin::Input*/}
                                                <label className="form-label required">
                                                  Articles of Association
                                                </label>
                                                <input
                                                  autoComplete="off"
                                                  type="file"
                                                  id="articles_of_association"
                                                  className="form-control"
                                                  onChange={(e) => {
                                                    processData(
                                                      "file",
                                                      e,
                                                      "articlesOfAssociation",
                                                    );
                                                  }}
                                                />
                                                {error.articlesOfAssociation !==
                                                  undefined &&
                                                  error.articlesOfAssociation !==
                                                  "" ? (
                                                  <small className="text-danger mt-2">
                                                    {
                                                      error.articlesOfAssociation
                                                    }
                                                  </small>
                                                ) : (
                                                  ""
                                                )}
                                                {loadingStep ===
                                                  "articlesOfAssociation" ? (
                                                  <small className="text-warning mt-2">
                                                    Please Wait File Uploding...
                                                  </small>
                                                ) : (
                                                  ""
                                                )}
                                                {/*end::Input*/}
                                                <div className="fv-plugins-message-container fv-plugins-message-container--enabled invalid-feedback"></div>
                                              </div>
                                            </div>
                                            <div className="col-md-12">
                                              <div className="fv-row mb-10 fv-plugins-icon-container">
                                                {/*begin::Input*/}
                                                <label className="form-label required">
                                                  Pricing Model
                                                </label>
                                                <Select
                                                  className="react-select-styled react-select-bordered"
                                                  classNamePrefix="react-select"
                                                  value={
                                                    models
                                                      ?.filter(
                                                        (model) =>
                                                          model?.value ===
                                                          data?.pricingModel,
                                                      )
                                                      ?.at(0) ?? null
                                                  }
                                                  onChange={(e) => {
                                                    processData(
                                                      "select",
                                                      e,
                                                      "pricingModel",
                                                    );
                                                  }}
                                                  options={models}
                                                  filterOption={(option, input) => {
                                                    return normalize(option.label).includes(normalize(input));
                                                  }}
                                                  placeholder="Select an option"
                                                />
                                                {error.pricingModel !==
                                                  undefined &&
                                                  error.pricingModel !== "" ? (
                                                  <small className="text-danger mt-2">
                                                    {error.pricingModel}
                                                  </small>
                                                ) : (
                                                  ""
                                                )}
                                                {/*end::Input*/}
                                                <div className="fv-plugins-message-container fv-plugins-message-container--enabled invalid-feedback"></div>
                                              </div>
                                            </div>

                                            {/*end::Col*/}
                                          </div>
                                          {/*end::Row*/}
                                        </div>
                                        {/*end::Input group*/}
                                      </div>
                                      {/*end::Wrapper*/}
                                      {/*begin::Actions*/}
                                      <div className="d-flex flex-stack">
                                        <div className="mr-2">
                                          <button
                                            type="button"
                                            className="btn btn-lg btn-primary"
                                            onClick={() => {
                                              setStage("info");
                                            }}
                                          >
                                            <i className="bi-duotone bi-arrow-left fs-4 ms-1">
                                              <span className="path1"></span>
                                              <span className="path2"></span>
                                            </i>
                                            Previous
                                          </button>
                                        </div>

                                        <div>
                                          <button
                                            type="button"
                                            className="btn btn-lg btn-primary"
                                            onClick={validateDocuments}
                                          >
                                            Next
                                            <i className="bi-duotone bi-arrow-right fs-4 ms-1">
                                              <span className="path1"></span>
                                              <span className="path2"></span>
                                            </i>
                                          </button>
                                        </div>
                                      </div>
                                      {/*end::Actions*/}
                                    </div>
                                  ) : (
                                    ""
                                  )}

                                  {/*end::Step 2*/}

                                  {/*begin::Step 3*/}
                                  {stage === "addresses" ? (
                                    <div className="current">
                                      {/*begin::Wrapper*/}
                                      <div className="w-100">
                                        {/*begin::Heading*/}
                                        <div className="pb-10 pt-5 pb-lg-12">
                                          {/*begin::Title*/}
                                          <h2 className="fw-bold text-dark">
                                            Merchant Address
                                          </h2>
                                          {/*end::Title*/}
                                        </div>
                                        {/*end::Heading*/}
                                        {/*begin::Input group*/}
                                        <div className="fv-row">
                                          {/*begin::Row*/}
                                          <div className="row">
                                            {/*begin::Col*/}
                                            <div className="col-md-12 mb-5">
                                              {/*begin::Checkbox*/}
                                              <div className="form-check form-check-custom">
                                                {/*begin::Input*/}
                                                <input
                                                  autoComplete="off"
                                                  className="form-check-input me-3"
                                                  type="checkbox"
                                                  checked={
                                                    data?.billingAndLegalAddressSame ??
                                                    false
                                                  }
                                                  onChange={() => {
                                                    setData((prev) => ({
                                                      ...prev,
                                                      billingAndLegalAddressSame:
                                                        !data.billingAndLegalAddressSame,
                                                    }));
                                                  }}
                                                />
                                                {/*end::Input*/}

                                                {/*begin::Label*/}
                                                <label
                                                  className="form-check-label"
                                                  htmlFor=""
                                                >
                                                  <div className="fw-bold text-gray-800">
                                                    Same Billing and Legal
                                                    Address
                                                  </div>
                                                </label>
                                                {/*end::Label*/}
                                              </div>
                                              {/*end::Checkbox*/}
                                            </div>
                                            <div className="col-md-12 mb-3">
                                              <BillingAddress
                                                data={data}
                                                processData={processData}
                                                error={error}
                                                setData={setData}
                                                setError={setError}
                                              />
                                            </div>
                                            {/*end::Col*/}
                                            {/*begin::Col*/}
                                            <div className="col-md-12 mb-3">
                                              <LegalAddress
                                                data={data}
                                                processData={processData}
                                                error={error}
                                                setData={setData}
                                                setError={setError}
                                              />
                                            </div>
                                            {/*end::Col*/}
                                            <div className="col-md-6">
                                              <div className="fv-row mb-10 fv-plugins-icon-container fv-plugins-bootstrap5-row-invalid">
                                                {/*begin::Input*/}
                                                <label className="form-label required">
                                                  Main Branch Phone Number
                                                </label>
                                                <input
                                                  autoComplete="off"
                                                  className="form-control"
                                                  placeholder="Enter Phone Number"
                                                  value={data.mainBranchPhone}
                                                  onChange={(e) => {
                                                    processData(
                                                      "text",
                                                      e,
                                                      "mainBranchPhone",
                                                    );
                                                  }}
                                                />
                                                {error.mainBranchPhone !==
                                                  undefined &&
                                                  error.mainBranchPhone !== "" ? (
                                                  <small className="text-danger mt-2">
                                                    {error.mainBranchPhone}
                                                  </small>
                                                ) : (
                                                  ""
                                                )}
                                                {/*end::Input*/}
                                                <div className="fv-plugins-message-container fv-plugins-message-container--enabled invalid-feedback"></div>
                                              </div>
                                            </div>
                                          </div>
                                          {/*end::Row*/}
                                        </div>
                                        {/*end::Input group*/}
                                      </div>
                                      {/*end::Wrapper*/}
                                      {/*begin::Actions*/}
                                      <div className="d-flex flex-stack">
                                        <div className="mr-2">
                                          <button
                                            type="button"
                                            className="btn btn-lg btn-primary"
                                            onClick={() => {
                                              setStage("documents");
                                            }}
                                          >
                                            <i className="bi-duotone bi-arrow-left fs-4 ms-1">
                                              <span className="path1"></span>
                                              <span className="path2"></span>
                                            </i>
                                            Previous
                                          </button>
                                        </div>

                                        <div>
                                          <button
                                            type="button"
                                            className="btn btn-lg btn-primary"
                                            onClick={validateAddresses}
                                          >
                                            Submit
                                            <i className="bi-duotone bi-arrow-right fs-4 ms-1">
                                              <span className="path1"></span>
                                              <span className="path2"></span>
                                            </i>
                                          </button>
                                        </div>
                                      </div>
                                      {/*end::Actions*/}
                                    </div>
                                  ) : (
                                    ""
                                  )}

                                  {/*end::Step 3*/}
                                </form>
                                {/*end::Form*/}
                              </div>
                              {/*end::Wrapper*/}
                            </div>
                            {/*end::Content*/}
                          </div>
                          {/*end::Body*/}
                        </div>
                        {/*end::Authentication - Multi-steps*/}
                      </div>
                      {/*end::Root*/}
                      {/*end::Main*/}
                    </div>
                    {/*end::Card body*/}
                  </div>
                </PermissionGate>
                {/*end::Card*/}
              </div>
              {/*end::Post*/}
            </div>
            {/*end::Container*/}
          </div>
          <Footer />
        </div>
        {/*end::Wrapper*/}
      </div>
      {/*end::Page*/}
    </div>
  );
};

export default CreateMerchant;
